// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"91":"GromaCoinWelcome","550":"GromaCoinWaitlist","657":"GromaCoinVerify","677":"GromaCoinNextSteps","809":"GromaCoinTransaction"}[chunkId] + "." + {"91":"c44ff1e9","550":"69eeb52a","657":"a1b7c7c9","677":"9981c520","809":"884913bf"}[chunkId] + ".chunk.css";
};